module.exports = __webpack_public_path__ + "img/table-sort.88ec2240.svg";